// Copyright (c) Docugami, Inc. All rights reserved.

import { primaryTheme } from "components/shell/presentation/AppStyles";
import styled from "styled-components";
import { ClauseList } from "./ClauseList";
import { useGetAllClausesQuery } from "store/assistedauthinfo/assistedAuthoringSlice";
import { createFolderId } from "components/file_management/file_helpers";
import { useAppSelector } from "hooks/redux";
import { selectClauseItems } from "store/assistedauthinfo/selectors";
import { WordTaskpaneLoadingPage } from "./WordTaskpane";
import { AddClauseCommandButton, ClauseLibraryPanePlaceholder } from "./ClauseLibraryComponents";

const ClauseLibraryContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background-color: ${primaryTheme.palette.neutralLighter};
`;

export interface ClauseLibraryProps {
    documentId: string;
}

export const ClauseLibrary = (props: ClauseLibraryProps): JSX.Element => {
    const docSetId = createFolderId(props.documentId).clusterId;
    const items = useAppSelector(state => selectClauseItems(state, docSetId));
    const { isLoading } = useGetAllClausesQuery(docSetId);

    if (isLoading) {
        return <WordTaskpaneLoadingPage />
    }

    return (
        <ClauseLibraryContainer>
            <AddClauseCommandButton documentId={props.documentId} docSetId={docSetId} />
            { !items.length ?
                <ClauseLibraryPanePlaceholder /> :
                <ClauseList documentId={props.documentId} items={items} />
            }
        </ClauseLibraryContainer>
    );
}